import type { ParticipantId, GroupId, WallId, WallParticipant, WallGroup } from '@walls/store/types';
import type { WallsClient } from './client';

export class ParticipantsApi {
  constructor(private readonly client: WallsClient) {}

  addParticipant = (
    boardId: WallId,
    name: string,
    inviteId?: string | null,
    key?: string | null
  ) => {
    return this.client.requestJson<{ participant: WallParticipant }>(
      `/boards/participant/${boardId}`,
      boardId,
      key,
      {
        method: 'POST',
        body: JSON.stringify({ name, inviteId }),
      }
    );
  };

  deleteParticipants = (boardId: WallId, participantIds: ParticipantId[], key?: string | null) => {
    return this.client.requestJson<void>(
      `/boards/participant/${boardId}/${participantIds.join(',')}`,
      boardId,
      key,
      {
        method: 'DELETE',
      }
    );
  };

  addGroup = (
    boardId: WallId,
    name: string,
    participantIds: ParticipantId[] = [],
    key?: string | null
  ) => {
    return this.client.requestJson<{ group: WallGroup }>(`/boards/groups/${boardId}`, boardId, key, {
      method: 'POST',
      body: JSON.stringify({ name, participantIds }),
    });
  };

  updateGroup = (boardId: WallId, groupId: GroupId, name: string, key?: string | null) => {
    return this.client.requestJson<{ group: WallGroup }>(
      `/boards/groups/${boardId}/${groupId}`,
      boardId,
      key,
      {
        method: 'PUT',
        body: JSON.stringify({ name }),
      }
    );
  };

  deleteGroup = (boardId: WallId, groupId: GroupId, key?: string | null) => {
    return this.client.requestJson<void>(`/boards/groups/${boardId}/${groupId}`, boardId, key, {
      method: 'DELETE',
    });
  };

  setGroupParticipants = (
    boardId: WallId,
    groupId: GroupId,
    participantIds: ParticipantId[],
    key?: string | null
  ) => {
    return this.client.requestJson<{ group: WallGroup }>(
      `/boards/groups/${boardId}/${groupId}/participants`,
      boardId,
      key,
      {
        method: 'PUT',
        body: JSON.stringify({ participantIds }),
      }
    );
  };
}
